import React from "react";

const UnitedHealthCare = ({
  pageKey,
  patient,
  patientIndex,
  handleFieldChange,
  handleRowChange,
  handleSubtotalChange,
}) => {
  const tableHeaders =
    patient.table && patient.table.length > 0
      ? Object.keys(patient.table[0])
      : [];

  const isEmpty = (val) =>  val === null || val === "";
  return (
    <div className="border border-gray-300 rounded-md p-4 mb-8 bg-white shadow">
      {/* Patient Name Header */}
      <h3 className="text-xl font-semibold text-purple-700 italic mb-2">
        Patient Name:{" "}
        <span className="text-pink-600">{patient["Patient Name"] || "Unnamed"}</span>
      </h3>

      {/* Patient Info (except table + subtotal) */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm mb-4">
        {Object.entries(patient)
          .filter(([key]) => key !== "table" && key !== "subtotal")
          .map(([key, value]) => (
            <div key={key}>
              <label className="font-semibold text-gray-700">{key}:</label>
              <input
              className={`!border p-1 w-full ${isEmpty(value) ? "border-2 border-red-700" : ""}`}
                value={value || ""}
                onChange={(e) =>
                  handleFieldChange(pageKey, patientIndex, key, e.target.value)
                }
              />
            </div>
          ))}
      </div>

      {/* Table */}
      <div className="overflow-auto">
        <table className="w-full text-xs border border-black">
          <thead className="bg-gray-200 text-black">
            <tr>
              {tableHeaders.map((header, i) => (
                <th
                  key={i}
                  className="border border-black p-1 text-center font-bold whitespace-pre-line"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(patient.table || []).map((row, rowIndex) => (
              <tr key={rowIndex}>
                {tableHeaders.map((key, colIndex) => (
                  <td key={colIndex} className="border border-black p-1 text-center">
                    <input
                      className={`w-full text-center bg-white !border ${isEmpty(row[key]) ? "border-2 border-red-700" : ""
                        }`}
                      value={row[key] || ""}
                      onChange={(e) =>
                        handleRowChange(
                          pageKey,
                          patientIndex,
                          rowIndex,
                          key,
                          e.target.value
                        )
                      }
                    />
                  </td>
                ))}
              </tr>
            ))}

            {/* Subtotal Row Styled like Image */}
            {patient.subtotal && (
              <>
                {/* Subtotal label row */}
                <tr>
                  <td
                    colSpan={tableHeaders.length}
                    className="text-left font-semibold text-sm px-2 py-1 pt-4"
                  >
                    SUBTOTAL:
                  </td>
                </tr>

                {/* Subtotal inputs row */}
                <tr className="bg-gray-50 font-semibold">
                  {tableHeaders.map((header, i) => (
                    <td key={i} className="border border-black p-1 text-center">
                      <input
                        className={`w-full text-center bg-white !border ${isEmpty(patient.subtotal[header]) ? "border-2 border-red-500" : ""
                          }`}
                        value={patient.subtotal[header] || ""}
                        onChange={(e) =>
                          handleSubtotalChange(
                            pageKey,
                            patientIndex,
                            header,
                            e.target.value
                          )
                        }
                      />
                    </td>
                  ))}
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UnitedHealthCare;
